module.exports = __webpack_public_path__ + "img/extended.99b70cbc.png";